import SvgGenerator from './SvgGenerator';

function convertRange(value, r1, r2) {
  return parseInt((((value - r1[0]) * (r2[1] - r2[0])) / (r1[1] - r1[0]) + r2[0]).toString(), 10);
}

const hash = str => {
  const arr = str.split('');
  return parseInt(
    Math.abs(
      arr.reduce(
        (hashCode, currentVal) =>
          (hashCode = currentVal.charCodeAt(0) + (hashCode << 6) + (hashCode << 16) - hashCode),
        0
      )
    )
      .toString()
      .substring(0, 2),
    10
  );
};

function getContrastHSP(hexColor) {
  const color = hexColor.replace('#', '');
  const R = parseInt(color.substring(0, 2), 16);
  const G = parseInt(color.substring(2, 4), 16);
  const B = parseInt(color.substring(4, 6), 16);
  const res = Math.sqrt(R * R * 0.241 + G * G * 0.691 + B * B * 0.068);
  return res < 145 ? '#fff' : '#222';
}

const AvatarInitials = ({ name, color, className, ...props }) => {
  const getInitials = () => {
    const displayName = name || '?';

    const initials = displayName
      .replace(/[&;]*/g, '')
      .match(/(^\S\S?|\s\S)?/g)
      ?.map(v => v.trim())
      .join('')
      .match(/(^\S|\S$)?/g)
      ?.join('')
      .toLocaleUpperCase();

    return initials || '';
  };

  const getSvg = () => {
    const displayName = name || '?';
    const colors = [
      '#ff80ed',
      '#065535',
      '#133337',
      '#ffc0cb',
      '#ffe4e1',
      '#008080',
      '#ff0000',
      '#e6e6fa',
      '#ffd700',
      '#ffa500',
      '#00ffff',
      '#ff7373',
      '#40e0d0',
      '#d3ffce',
      '#c6e2ff',
      '#b0e0e6',
      '#f0f8ff',
      '#faebd7',
      '#bada55',
      '#003366',
      '#fa8072',
      '#ffff00',
      '#ffb6c1',
      '#800000',
      '#7fffd4',
      '#800080',
      '#c39797',
      '#00ff00',
      '#20b2aa',
      '#f08080',
      '#fff68f',
      '#ffc3a0',
      '#66cdaa',
      '#c0d6e4',
      '#ff6666',
      '#ffdab9',
      '#ff7f50',
      '#cbbeb5',
      '#468499',
      '#afeeee',
      '#00ced1',
      '#008000',
      '#f6546a',
      '#b4eeb4',
      '#b6fcd5',
      '#660066',
      '#0e2f44',
      '#990000',
      '#6897bb',
      '#daa520',
      '#000080',
      '#088da5',
      '#8b0000',
      '#f5f5dc',
      '#ffff66',
      '#8a2be2',
      '#81d8d0',
      '#0a75ad',
      '#ccff00',
      '#2acaea',
      '#ff4040',
      '#66cccc',
      '#420420',
      '#ff1493',
      '#a0db8e',
      '#00ff7f',
      '#cc0000',
      '#3399ff',
      '#794044',
    ].map(hex => ({
      bg: hex,
      text: getContrastHSP(hex),
    }));

    const hashNumber = convertRange(hash(displayName), [0, 99], [0, colors.length - 1]);
    let chosenColor = colors[hashNumber];
    if (color) {
      chosenColor = {
        bg: color,
        text: getContrastHSP(color),
      };
    }

    const svg = new SvgGenerator()
      .text(getInitials())
      .fontWeight(600)
      .bgColor(chosenColor.bg)
      .textColor(chosenColor.text)
      .generate();

    return 'data:image/svg+xml,' + encodeURIComponent(svg);
  };

  return <img src={getSvg()} className={className} alt={`${name || 'User'}`} {...props} />;
};

export default AvatarInitials;
